import React from 'react'

function CompanyName() {
  const CompanyName = 'National Save The Sea Turtle Foundation'
  return (
    <span title='National Save The Sea Turtle Foundation'>{CompanyName}</span>
  )
}
export default CompanyName;